import React, { useEffect, useState } from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Button from '@material-ui/core/Button';
import DownloadIcon from '@material-ui/icons/CloudDownload';
import { Toast } from 'primereact/toast';
import CircularProgress from '@material-ui/core/CircularProgress';

import './RelatorioDemandaCirurgica.css';

import { dominioDemandaCirurgica } from 'config/database';

export default function RelatorioDemandaCirurgica() {
  const [relatorios, setRelatorios] = useState([]);
  const [relatorio, setRelatorio] = useState();
  const [loading, setLoading] = useState(false);

  const myToast = React.useRef(null);

  useEffect(() => {
    dominioDemandaCirurgica.get('/api/listarRelatorios').then(response => {
      setRelatorios(response.data);
    });
  }, []);

  const handleGenerateReport = async () => {
    if (!relatorio) {
      myToast.current.show({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Selecione um relatório!',
        life: 5000,
      });
      return;
    }

    setLoading(true);

    await dominioDemandaCirurgica.get(`/${relatorio.link}`).then(() => {
      myToast.current.show({
        severity: 'success',
        summary: 'Atenção',
        detail: `Estamos processando o relatório para download. Por favor, aguarde.`,
        life: 15000,
      });

      const enderecoAtual = window.location.href;

      if (
        enderecoAtual === 'https://operahc2.famema.br:4576/admin/relatorioDemandaCirurgica' ||
        enderecoAtual === 'http://localhost:3000/admin/relatorioDemandaCirurgica'
      ) {
        window.location.href = `https://operamanagerhc2.famema.br:4577/${relatorio.link}`;
      } else {
        window.location.href = `https://operamanagerhc.famema.br/${relatorio.link}`;
      }

      setLoading(false);
    });
  };

  return (
    <div className="container-report">
      <Toast ref={myToast} />

      <Autocomplete
        id="combo-box-demo"
        options={relatorios}
        getOptionLabel={option => option.descricao}
        style={{ width: 600 }}
        renderInput={params => (
          <TextField {...params} label="Selecione o relatório" variant="outlined" />
        )}
        value={relatorio}
        onChange={(e, values) => {
          setRelatorio(values);
        }}
      />

      <Button
        className="button-report"
        variant="contained"
        color="primary"
        startIcon={loading ? '' : <DownloadIcon />}
        onClick={handleGenerateReport}
        disabled={loading}
      >
        {loading ? <CircularProgress disableShrink /> : 'BAIXAR RELATÓRIO'}
      </Button>
    </div>
  );
}
